'use client';
import { useTranslations } from 'next-intl';
import type { FC } from 'react';

export const UpgradeLabel: FC = () => {
  const t = useTranslations();
  return (
    <div className="absolute top-0 right-0 rounded-bl-12 bg-system-blue02 px-3 py-[2px] font-medium text-system-white text-xs">
      {t('create.createForm.badge.upgrade')}
    </div>
  );
};
